import { Tooltip } from "@mui/material";
import { useEffect, useState } from "react";

interface toggleType {
  click?: (node?: any) => void;
  checked?: boolean;
  toolTip?: boolean;
  node?: any;
  data?: any;
  change?: any;
}

const ToggleButton = ({
  click,
  checked,
  toolTip = false,
  node,
  data,
  change,
}: toggleType) => {
  const [toggleState, setToggleState] = useState(node ? node?.value : false);
  console.log("dataToggle", data, toggleState, click);

  useEffect(() => {
    setToggleState(node?.value);
  }, [node?.value]);

  const handleClick = () => {
    if (data && node && change) {
      let tempData = [...data];
      setToggleState(!toggleState);
      tempData.forEach((element: toggleType["node"]) => {
        if (
          element?.title.trim().toLowerCase() ===
          node?.title.trim().toLowerCase()
        ) {
          element.value = !toggleState;
        }
      });
      console.log("styleeeee", tempData);

      change([...tempData]);
    }
  };

  return (
    <div
      key={node?.name}
      className={`flex items-center ${node?.parentStyle ?? ""}  p-2 `}
    >
      {node?.title && <span>{node?.title}</span>}
      {node?.style ? (
        <button
          onClick={() => (click ? click(node) : handleClick())}
          className={`w-12 h-7 flex items-center  ${checked || node?.value ? node?.style?.activeBg ?? "bg-primary" : "bg-primary-alpha-40"} rounded-full mx-3 px-1  cursor-pointer`}
        >
          {toolTip ? (
            <Tooltip title={checked ? "Enabled" : "Disabled"} arrow>
              <div
                className={` w-5 h-5 rounded-full shadow-md transform transition-transform ${
                  checked
                    ? "translate-x-5 bg-ternary"
                    : "translate-x-0 bg-ternary-text"
                }`}
              ></div>
            </Tooltip>
          ) : (
            <div
              className={` w-5 h-5 rounded-full shadow-md transform transition-transform ${
                checked || node?.value
                  ? `translate-x-5 ${node?.style?.iconColor ?? "bg-ternary"}`
                  : `translate-x-0 ${node?.style?.iconColor ?? "bg-ternary-text"}`
              }`}
            ></div>
          )}
        </button>
      ) : (
        <button
          onClick={() => (click ? click(node) : handleClick())}
          className={`w-8 h-4 flex items-center ${checked || node?.value ? node?.style?.activeBg ?? "bg-primary" : "bg-primary-alpha-40"} rounded-full mx-3 px-1  cursor-pointer`}
        >
          {toolTip ? (
            <Tooltip title={checked ? "Enabled" : "Disabled"} arrow>
              <div
                className={` w-3 h-3 rounded-full shadow-md transform transition-transform ${
                  checked
                    ? "translate-x-3 bg-ternary"
                    : "translate-x-0 bg-ternary-text"
                }`}
              ></div>
            </Tooltip>
          ) : (
            <div
              className={` w-3 h-3 rounded-full shadow-md transform transition-transform ${
                checked || node?.value
                  ? `translate-x-3 ${node?.style?.iconColor ?? "bg-ternary"}`
                  : `translate-x-0 ${node?.style?.iconColor ?? "bg-ternary-text"}`
              }`}
            ></div>
          )}
        </button>
      )}
    </div>
  );
};
export default ToggleButton;
